import React from 'react'
import FeedbackForm from './FeedbackForm'
import FeedbackConfirm from './FeedbackConfirm'

export default class Feedback extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      feedbackSuccess: false,
      formComplete: true
    }
  }

  updateSuccess = bool => {
    this.setState({ feedbackSuccess: bool })
  }

  render() {
    let { feedbackSuccess } = this.state.feedbackSuccess

    return (
      <div>
        <FeedbackForm
          updateSuccess={this.updateSuccess}
          feedbackSuccess={feedbackSuccess}
          formComplete={this.state.formComplete}
        />
        <FeedbackConfirm formComplete={this.state.formComplete}/>
      </div>
    )
  }
}